export default "__VITE_ASSET__DjfAG6dv__"